import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, CardTitle, Alert, Label, Input, Badge } from "reactstrap"
import { post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ITEMS_PER_PAGE } from "helpers/pagination_helper";
import Loader from "common/loader";
import { USERS_SEARCH } from "helpers/api_endpoints";
//meta title
document.title = "Users";
const UsersList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [filters, setFilters] = useState({});
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [successMsg, setsuccessMsg] = useState('');

    useEffect(() => {
        successMessage();
        post(`${USERS_SEARCH}?paginate=${ITEMS_PER_PAGE}&page=${page}`, filters)
            .then(response => {
                const data = response.data;
                setUsers(data.data);
                setTotalPages(data.pagination.totalPages);
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status == 401) {
                    navigate('/logout');
                }
            })
    }, [page, filters]);


    const successMessage = () => {
        if (location.state) {
            setsuccessMsg(location.state.successMsg);
            setTimeout(() => {
                setsuccessMsg('');
            }, 4000)
        }
    };

    const handleFilter = (type, value) => {
        const filtvalues = {};
        if (value) {
            switch (type) {
                case 'name':
                    setName(value);
                    filtvalues.name = value;
                    break;
                case 'email':
                    setEmail(value);
                    filtvalues.email = value;
                    break;
                case 'status':
                    setStatus(value);
                    filtvalues.status = value;
                    break;
                case 'mobile':
                    setMobile(value);
                    filtvalues.mobile = value;
                    break;
                default:
                    break;
            }
        }
        setFilters(filtvalues);
    }

    const handlePrevPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const handleNextPage = () => {
        if (page < totalPages) {
            setPage(page + 1);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Home" breadcrumbItem="Users" />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <br></br>
                                {successMsg ? <Alert style={{ margin: "25px" }} color="success">{successMsg}</Alert> : null}
                                <CardTitle>
                                    <Link to="/users/add" >
                                        <button style={{ float: "right", marginRight: "20px" }} className="btn btn-sm btn-primary"><i className="dripicons-plus"></i> &nbsp;<Trans>Create</Trans></button>
                                    </Link>
                                </CardTitle>

                                <div style={{ margin: "25px" }}>
                                    <Row>
                                        <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label"><Trans>Name</Trans></Label>
                                            <Input
                                                name="name"
                                                // value={name}
                                                className="form-control"
                                                placeholder="Enter Name"
                                                type="text"
                                                onChange={(e) => handleFilter('name', e.target.value)}
                                                onKeyDown={(e) => handleFilter('name', e.target.value)}
                                            ></Input>
                                        </div>
                                        <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label"><Trans>Email</Trans></Label>
                                            <Input
                                                name="email"
                                                // value={name}
                                                className="form-control"
                                                placeholder="Enter Email"
                                                type="email"
                                                onChange={(e) => handleFilter('email', e.target.value)}
                                                onKeyDown={(e) => handleFilter('email', e.target.value)}
                                            ></Input>
                                        </div>
                                        <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label"><Trans>Mobile</Trans></Label>
                                            <Input
                                                name="mobile"
                                                // value={name}
                                                className="form-control"
                                                placeholder="Enter Mobile"
                                                type="text"
                                                onChange={(e) => handleFilter('mobile', e.target.value)}
                                                onKeyDown={(e) => handleFilter('mobile', e.target.value)}
                                            ></Input>
                                        </div>
                                    </Row>
                                </div>


                                <CardBody>
                                    <div className="table-responsive">
                                        <Table className="table table-striped table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th><Trans>ID</Trans></th>
                                                    <th><Trans>Name</Trans></th>
                                                    <th><Trans>Email</Trans></th>
                                                    <th><Trans>Mobile</Trans></th>
                                                    <th><Trans>Status</Trans></th>
                                                    <th><Trans>Created At</Trans></th>
                                                    <th>#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? <tr><th colSpan={6} className="text-center"><Loader></Loader></th></tr> : null}
                                                {
                                                    users.map((user, index) => (
                                                        <tr key={index}>
                                                            <td>{user.id}</td>
                                                            <td>{user.name}</td>
                                                            <td>{user.email}</td>
                                                            <td>{user.mobile}</td>
                                                            <td>{(user.status == 1) ? <Badge className="bg-success"><Trans>Active</Trans></Badge> : <Badge className="bg-danger"><Trans>Non Active</Trans></Badge>}</td>
                                                            <td>{user.createdAt}</td>
                                                            <td>
                                                                <Link to={`/users/edit/${user.id}`}><button className="btn btn-sm btn-info"><i className="dripicons-pencil"></i> &nbsp;<Trans>Edit</Trans></button></Link> &nbsp;
                                                                <Link to={`/users/remove/${user.id}`}><button className="btn btn-sm btn-danger" ><i className="dripicons-trash"></i> &nbsp;<Trans>Remove</Trans> </button></Link>
                                                                <Link to={`/users/address/${user.id}`}><button className="btn btn-sm btn-info"><i className="dripicons-pencil"></i> &nbsp;<Trans>Addresses</Trans></button></Link>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                    <br></br>
                                    <div className="text-center">
                                        {/* Pagination controls */}
                                        <button className="btn btn-sm btn-dark" onClick={handlePrevPage} disabled={page === 1}>
                                            <Trans>Previous</Trans>
                                        </button>&nbsp;
                                        <button className="btn btn-sm btn-dark" onClick={handleNextPage} disabled={page === totalPages}>
                                            <Trans>Next</Trans>
                                        </button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    )
}

export default UsersList
